import { render, staticRenderFns } from "./fenlei.vue?vue&type=template&id=9814204a&scoped=true"
import script from "./fenlei.vue?vue&type=script&lang=js"
export * from "./fenlei.vue?vue&type=script&lang=js"
import style0 from "./fenlei.vue?vue&type=style&index=0&id=9814204a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9814204a",
  null
  
)

export default component.exports